import type { SxProps, Theme } from '@mui/material/styles';

export const totalPillSx: SxProps<Theme> = {
  cursor: 'default',
  backgroundColor: (theme) => theme.palette.grey[50],
  '&:hover': { backgroundColor: (theme) => theme.palette.grey[50] },
};

export const totalLabelSx: SxProps<Theme> = {
  color: (theme) => theme.palette.grey[500],
  fontWeight: 400,
};

export const paginationInfoPillSx: SxProps<Theme> = {
  gap: '12px',
};

export const pageSizeArrowIconSx: SxProps<Theme> = {
  fontSize: '20px',
  color: (theme) => theme.palette.grey[500],
  ml: '4px',
};

export const pageSizeMenuPaperSx: SxProps<Theme> = {
  minWidth: 100,
};
